const isProd = process.env.NODE_ENV === 'production'
const isMock = process.env.REACT_APP_MOCK !== undefined

let langText = null

const getLangText = supportedLanguages => {
  langText = langText
    ? langText
    : supportedLanguages.reduce((prev, lang) => {
        prev[lang] = ''
        return prev
      }, {})
  return langText
}

const config = {
  isProd,
  isMock,
  apiEndpoint: isProd
    ? 'https://p.allly.co/api'
    : 'http://localhost:8000/api',

  imageURLPrefix: isProd
    ? 'https://p.allly.co/images'
    : 'http://localhost:8000/images',
  defaultLanguage: 'th',
  supportedLanguages: ['th', 'en', 'zh'],
  getLangText: function() {
    return getLangText(this.supportedLanguages)
  },
}

export default config



// WEBPACK FOOTER //
// ./src/config.js